'use client';

import Header from "@/components/structure/Header";
import {useNavigation} from '@/contexts/NavigationContext';

/**
 * Header wrapper that gets navigation configuration from context
 * Pages can set their own navigation sections using the NavigationContext
 */
export default function HeaderWrapper() {
    const { sections, ticketRef, showSocialLinks } = useNavigation();

    return (
        <Header
            sections={sections}
            ticketRef={ticketRef}
            showSocialLinks={showSocialLinks}
        />
    );
}